export var Routes;

(function (Routes) {
  Routes["All"] = "*";
  Routes["Main"] = "/";
  Routes["Login"] = "/login";
  Routes["UploadContainer"] = "/upload-container";
  Routes["PhoneNumber"] = "/phone";
  Routes["Sms"] = "/otp";
  Routes["Password"] = "/password";
  Routes["Home"] = "/users";
  Routes["WisperUsers"] = "/wisper-users";
  Routes["Groups"] = "/groups";
  Routes["Billing"] = "/billing";
  Routes["Log"] = "/log";
  Routes["Settings"] = "/settings";
  Routes["Pin"] = "/pin";
  Routes["Encryption"] = "/encryption";
  Routes["Error"] = "/error";
  Routes["NotFound"] = "/404";
  Routes["HealthCheck"] = "/healthz";
})(Routes || (Routes = {}));

export var Flow;

(function (Flow) {
  Flow["SignIn"] = "signIn";
  Flow["SignUp"] = "signUp";
})(Flow || (Flow = {}));